"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
var Dropdown_style_1 = __importDefault(require("./Dropdown.style"));
function calculateDropdownTopPosition(anchor) {
    if (!anchor) {
        return 0;
    }
    var bottom = anchor.getBoundingClientRect().bottom;
    var dropdownTopSpacingPx = 8;
    return bottom + dropdownTopSpacingPx;
}
/**
 * Dropdown atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-dropdown--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/Dropdown Source}
 */
var Dropdown = function (_a) {
    var horizontalAlignment = _a.horizontalAlignment, anchorElement = _a.anchorElement, closeMenu = _a.closeMenu, children = _a.children, _b = _a.verticalAnchorOrigin, verticalAnchorOrigin = _b === void 0 ? 'bottom' : _b, _c = _a.verticalTransformOrigin, verticalTransformOrigin = _c === void 0 ? 'top' : _c;
    var classes = (0, Dropdown_style_1.default)();
    var dropdownTopPosition = calculateDropdownTopPosition(anchorElement);
    var dynamicRoot = (0, makeStyles_1.default)(function () { return ({
        dynamicRoot: {
            // Unfortunately we need this styles otherwise MUI would push dropdown over the anchor element
            top: "".concat(dropdownTopPosition, "px !important"),
            maxHeight: "calc(100vh - ".concat(dropdownTopPosition + theme_1.default.globalPadding, "px)"),
        },
    }); })().dynamicRoot;
    return ((0, jsx_runtime_1.jsx)(core_1.Popover, __assign({ open: !!anchorElement, anchorEl: anchorElement, onClose: closeMenu, transitionDuration: theme_1.default.popoverTransitionDuration, anchorOrigin: {
            vertical: verticalAnchorOrigin,
            horizontal: horizontalAlignment,
        }, transformOrigin: {
            vertical: verticalTransformOrigin,
            horizontal: horizontalAlignment,
        }, classes: {
            paper: (0, classnames_1.default)(classes.root, verticalAnchorOrigin === 'bottom' ? dynamicRoot : classes.anchorOriginVerticalTop),
        } }, { children: children })));
};
exports.Dropdown = Dropdown;
